
import { Component, Vue } from 'vue-property-decorator';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/community`,
  query_city: `${FCAPI}/boss/ruan/community/city`,
};
const OPTION_LIST = [
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '名称',
    align: 'center',
    dataIndex: 'name',
  },
  {
    title: '城市',
    align: 'center',
    dataIndex: 'city',
  },
  {
    title: '上架状态',
    align: 'center',
    dataIndex: 'is_show',
    scopedSlots: { customRender: 'show' },
  },
  {
    title: '最新编辑时间',
    align: 'center',
    scopedSlots: { customRender: 'time' },
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  },
];
interface FORM {
  name?: string;
  city?: string;
  is_show?: number | string;
}
interface DATA {
  id: number;
  name: string;
  city: string;
  list_img_url?: string;
  is_show: number;
  create_time?: number;
  update_time?: number;
}
@Component
export default class Community extends Vue {
  columns = OPTION_LIST; // 列表列信息选项
  data: DATA[] = []; // 获取到的列表数据
  city_list: DATA[] = [];
  is_loading = false; // 加载状态
  delete_item = ''; //
  page = 1;
  table_data = {};
  form: any = {
    city: undefined,
    name: '',
    is_show: '全部',
  }; // 筛选表单数据

  created() {
    // TODO获取数据
    this.query();
  }
  // 获取数据
  async query(sende_data = {}, page = 1) {
    this.is_loading = true;
    this.page = page;
    const { data } = await this.$axios.get(API.query, {
      params: { current: this.page, ...sende_data },
    });
    this.is_loading = false;
    if (data.status !== 200) {
      this.data = [];
      this.table_data = {
        current: 0,
        limit: 5,
        total: 0,
      };
      return;
    }
    this.data = data.data.detail;
    this.table_data = data.data;
  }
  // 获取所有城市
  async queryCity() {
    const { data } = await this.$axios.get(API.query_city);
    if (data.status !== 200) return [];
    return data.data;
  }

  // 搜索所有符合条件的结果
  hanleSearch() {
    let send_data = {};
    // 如果is_show字段是空或者全部，那么发送给后端的数据就不需要is_show字段
    if (this.form.is_show === '全部' || this.form.is_show === '') {
      send_data = {
        name: this.form.name,
        city: this.form.city,
      };
    } else {
      let is_show = parseInt(this.form.is_show);
      send_data = { ...this.form, is_show };
    }
    this.query(send_data);
  }

  // 搜索输入框中的城市
  async handleSearchCity(value: string) {
    const result = await this.queryCity();
    const _list = result.filter((item: any) => !item.city.indexOf(value));
    this.city_list = _list;
  }

  // 处理筛选框中的城市选择事件
  handleCityChange(value: string) {
    this.form.city = value;
  }
  // 清空搜索条件
  handleEmpty() {
    this.form = {
      name: '',
      city: undefined,
      is_show: '全部',
    };
  }

  // 提交编辑排序
  async submitSortEdit(item: any) {
    if (item.sort !== '') {
      const { data } = await this.$axios.put(`${API.query}/${item.id}`, {
        sort: item.sort,
      });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.query();
      this.$message.success('编辑成功');
    }
  }
  // 处理编辑事件,跳转页面
  handleEdit(data: any) {
    this.$router.push({
      name: 'add-community',
      params: { title: '编辑小区', data },
    });
  }

  // 点击新增小区，跳转页面
  handleAdd() {
    this.$router.push({ path: '/ruan/community-detail/0' });
  }

  // 处理点击上下架事件
  async handleStatus(item: any) {
    this.delete_item = item;
    if (item.is_show === 1) {
      const { data } = await this.$axios.put(`${API.query}/${item.id}`, {
        is_show: 2,
      });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('下架成功');
    } else {
      const { data } = await this.$axios.put(`${API.query}/${item.id}`, {
        is_show: 1,
      });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('上架成功');
    }
    this.query(this.page);
  }

  // 分页
  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  // 页数改变
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }
  // 格式化时间
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
}
